import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createTicket } from "../../services/api";
import { buildSuccessPageState, buildTicketData, getTicketFormError } from "./ticketFormHelpers";
import { useSubmitFeedback } from "./useSubmitFeedback";

// Sending the ticket: checks the form, opens the ticket and moves to the success page,
// or shows why it wasn't opened
export const useTicketSubmit = ({ data, openedViaDevice, formData, address, contact, setSnackbar }) => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const feedback = useSubmitFeedback(setSnackbar);
  const { addressChangeRequest } = address;
  const { contactNameChangeRequest, contactPhoneChangeRequest, contactEmailChangeRequest } = contact;

  const handleSave = async () => {
    const formError = getTicketFormError({
      formData,
      addressChangeRequest,
      contactNameChangeRequest,
      contactPhoneChangeRequest,
    });
    if (formError) {
      setSnackbar({ open: true, message: formError, severity: "error" });
      return;
    }

    setIsSubmitting(true);
    try {
      const ticketData = buildTicketData({
        data,
        formData,
        openedViaDevice,
        addressChangeRequest,
        contactNameChangeRequest,
        contactPhoneChangeRequest,
        contactEmailChangeRequest,
      });

      const response = await createTicket(ticketData);

      navigate("/successful", buildSuccessPageState({ ticketData, formData, data, response }));
    } catch (error) {
      feedback.handleSubmitError(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return { ...feedback, isSubmitting, handleSave };
};
